import classnames from "classnames";
import { memo } from "react";

import { ISelectOptionExtended } from "types";

export interface IRadioButtonsFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  id?: string;
  options: Array<ISelectOptionExtended>;
  group: string;
  classNames?: {
    inputWrapper?: string;
    inputWrapperActive?: string;
  };
}

function RadioButtonsField({
  id,
  options,
  className,
  value,
  classNames,
  ...rest
}: IRadioButtonsFieldProps) {
  const classes = classnames("select", className);
  return (
    <div className={classnames(classes, "flex")}>
      {options.map((item, index) => {
        const checked = item.value === value;
        return (
          <div
            className={classnames(
              "flex items-center ",
              classNames?.inputWrapper || "mr-8 whitespace-nowrap", {
                [classNames?.inputWrapperActive || '']: checked
              }
            )}
            key={index}
          >
            <input
              style={{
                appearance: "none",
                width: "18px",
                height: "18px",
              }}
              type="radio"
              id={rest.group + index}
              name="contact"
              value={item.value || ""}
              className={classnames(
                "mr-2 border border-solid relative cursor-pointer rounded-full flex justify-center items-center flex-col box-content flex-shrink-0",
                {
                  "border-pattensBlue": !checked,
                  "border-primaryBlue": checked,
                  "before:block before:bg-primaryBlue before:w-[10px] before:h-[10px] before:rounded-full before:absolute":
                    checked,
                }
              )}
              checked={checked}
              {...rest}
            />
            <label htmlFor={rest.group + index} className="cursor-pointer">
              {item.label}
            </label>
          </div>
        );
      })}
    </div>
  );
}

RadioButtonsField.defaultProps = { options: [] };

export default memo(RadioButtonsField);
